/**
 * Конверт сообщения: то общее, с чего начинается каждый разборщик.
 *
 * ПОЧЕМУ ЭТО ОТДЕЛЬНО И ПОЧЕМУ ОДНО НА ВСЕХ. Получатель не знает
 * заранее, что ему прислали, и прогоняет сообщение по цепочке
 * разборщиков, пока кто-нибудь его не узнает. Пока разбор строки жил
 * внутри каждого из них, одна и та же строка разбиралась столько раз,
 * сколько разборщиков стояло перед нужным, — до тринадцати в оверлее
 * и по разу на каждого из двадцати подписчиков в пульте. При
 * перетаскивании тройки слоёв это тысячи разборов в секунду ровно
 * на той машине, где в этот же момент OBS кодирует видео.
 *
 * Отсюда правило: строка разбирается ОДИН РАЗ на входе, дальше
 * по цепочке идёт уже объект. Держится оно тем, что здесь принимаются
 * оба вида, и каждый разборщик зовёт именно это.
 *
 * ВОЗВРАЩАЕТ null, А НЕ БРОСАЕТ. Сообщение приходит из сети, и чужая
 * форма не должна ронять ни эфир, ни пульт: неразобранное — это
 * «не моё», и вызывающий передаёт его дальше.
 */
export function decodeMessage(raw) {
    if (typeof raw === 'string') {
        let parsed;
        try {
            parsed = JSON.parse(raw);
        }
        catch {
            return null;
        }
        return asEnvelope(parsed);
    }
    return asEnvelope(raw);
}
/**
 * Объект, но не массив и не null.
 *
 * Массив проверяется отдельно, хотя typeof и называет его объектом:
 * без этого он прошёл бы дальше конвертом с полем `t` равным
 * undefined, и отвергал бы его уже каждый разборщик по отдельности.
 */
function asEnvelope(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return null;
    return value;
}
//# sourceMappingURL=message.js.map